import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {__,__n} from "i18n-for-browser";

/*
* Import Components
 */
import GoBackButton from "../elements/GoBackButton";
import ContentContainer from "../elements/ContentContainer";

/*
* Import helpers
 */
import { getContent } from "../../helpers/popupHelper";
import { getPopupDeviceDifficulty, getPopupCurrentGame } from "../../helpers/popupHelper";
import PopUp from "../elements/PopUp";
import apiCall from '../apiCall';
import { getCookie, setCookie } from 'glxl-helpers/lib/util/cookie';

class GameInfo extends Component {
  static defaultProps = {
    desktop: false,
  };
  constructor(props) {
    super(props);
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
    const gameId = parseInt(props.match.params.gameid, 10);
    const {props: { schoolClass }} = this;
    this.state = {
      curGame: (schoolClass.SchoolClassGames.find(game => game.GameId === gameId)).Game,
      gameId: gameId,
      popupId: '',
      showPopUp: false,
    }
    this.curGame = (schoolClass.SchoolClassGames.find(game => game.GameId === gameId)).Game;
  };

  getSubtitle = () => {
    const { project } = this.props;

    if (project.EducationProject.nameShort === 'GLXL') {
      return __('sim_globas_verdienen');
    } else {
      return __n('sim_spel', 0);
    }
  }

  renderButton = (game) => {
    const { state: { gameId }, props: { user, gameState, schoolClass }} = this;
    console.log(gameState.currentlyPlaying);
    const playing = gameState.currentlyPlaying === gameId;
    const curGame = schoolClass.SchoolClassGames.find(game => game.GameId === gameId);
    if (!game.isSeriousGamesMinigame) {
      if (curGame && curGame.Game && !curGame.Game.hasContent && !curGame.Game.softwareLocation) return false;
    }
    const rounds = this.props.gameState.Rounds;
    const round = rounds[rounds.length - 1];
    const finished = round && round.GameId === gameId && round.state === "SCORE_SUBMITTED";
    if (!game.isSeriousGamesMinigame) {
      if (curGame.Game.abbreviation === "DT") return null;
    }
    return (
      <div className={'center-button'}>
        <button
          onClick={async () => {
            if(user.role === "groupmember" && curGame.Game.abbreviation === "FQ") {
              this.setState({
                popupId: 'mlgmtussenschermfilmquiz_3',
              })
              this.togglePopup();
            } else if (finished) {
              this.setState({
                popupId: 'dlgmtussenschermghettoradio_2',
              })
              this.togglePopup();
            } else if (playing) {
              if (game.isSeriousGamesMinigame && this.props.schoolClass.lastOpenedSeriousGamesMinigame != game.abbreviation) {
                this.setState({
                  popupId: 'dhgmvghettoradio_1_sgspelnognietgeopend',
                })
                this.togglePopup();
                return;
              }
              if (game.softwareLocation || game.isSeriousGamesMinigame) {
                if (!game.isSeriousGamesMinigame && game.softwareLocation.startsWith('/') && !game.softwareLocation.startsWith('//')) {
                  window.location.href = game.softwareLocation;
                } else {
                  if (game.isSeriousGamesMinigame)  {
                    let seriousGamesPlayerToken = getCookie(`seriousGamesPlayerToken-${this.props.user.userDetails.group.id}`);
                    const { token, maxPlayersReached } = (await apiCall('/seriousgames/playerLoginToken', { token: seriousGamesPlayerToken }, 'POST'));
                    seriousGamesPlayerToken = token;
                    if (token) {
                      setCookie(`seriousGamesPlayerToken-${this.props.user.userDetails.group.id}`, seriousGamesPlayerToken, 30);
                      window.open(`${game.seriousGamesSoftwareLocation}?token=${encodeURIComponent(seriousGamesPlayerToken)}`);
                    } else {
                      if (maxPlayersReached) {
                        // @TODO: popup toevoegen in sheet?
                        this.setState({
                          popupId: 'dlgmtussenschermhotlist_maxteamleden',
                        })
                        this.togglePopup();
                      } else {
                        alert("Er is iets misgegaan bij het ophalen van de inlog token voor Serious Games.");
                        // @TODO: popup toevoegen in sheet?
                        // this.setState({
                        //   popupId: 'mlgvtussenschermghettoradio_1',
                        // })
                        // this.togglePopup();
                      }
                    }
                  } else {
                    window.open(`${game.softwareLocation}?token=${user.token}`);
                  }
                }
              } else {
                this.props.history.push(`/portal/game/${game.id}`)
              }
            } else {
              this.setState({
                popupId: 'dhgmvghettoradio_1',
              })
              this.togglePopup();
            }
          }}
          className={'button ' + (playing && (game.isSeriousGamesMinigame ? this.props.schoolClass.lastOpenedSeriousGamesMinigame == game.abbreviation : true) ? '' : 'disabled')} style={{pointerEvents: 'all'}}>
          <span>{__('sim_naar_het_spel')}</span>
        </button>
      </div>
    )

  }

  togglePopup = () => {
    this.setState({
      showPopUp: !this.state.showPopUp
    })
  }

  render() {
    const { props: { gameState } } = this;

    if (!this.state.curGame) {
      return (
        <div className={'error-page container'}>
          <GoBackButton history={this.props.history} />
          <p>{__('sim_standaard_foutmelding')}</p>
        </div>
      )
    }

    if(this.state.curGame.abbreviation) {
      this.curGame = getPopupCurrentGame(this.state.curGame.abbreviation);
    } else {
      this.curGame = getPopupCurrentGame(this.state.gameId);
    }

    return (
      <div className={`gamepage portal-home darkBckg ${(this.props.desktop ? ' desktop-single' : '')}`}>
        <div className={'container'}>
          <div className={'title-block title-portal'}>
            <GoBackButton history={this.props.history} />
            <h3>{this.state.curGame.name}</h3>
            <p>{this.getSubtitle()}</p>
          </div>

          <div>
            <ContentContainer className={'content-detail-game'}>
              <span dangerouslySetInnerHTML={{ __html: getContent(`${this.deviceAndDifficulty}gvt${this.curGame}`, gameState.language) }}/>
            </ContentContainer>

            {this.renderButton(this.state.curGame)}
          </div>
          { this.state.showPopUp ? (
            <PopUp popUpFooter={true} id={this.state.popupId} closePopUpClick={this.togglePopup}/>
          ) : null }
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    user: state.user,
    project: state.project,
    schoolClass: state.schoolClass,
    gameState: state.gameState,
  }
})(GameInfo);



// WEBPACK FOOTER //
// ./src/components/routes/GameInfo.js